module.exports = __webpack_public_path__ + "1da3b0e2e52f9f71301b1e4b78a75f51.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RoundedMplus1c-Light.ttf
// module id = 25
// module chunks = 0